module.exports = __webpack_public_path__ + "img/favicon.83eb0df8.png";